// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorMessage_errorContainer__JEEl8","error":"ErrorMessage_error__5b7lL"};